import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination } from '@mui/material'
import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../hooks/axiosInstance'
import { toast } from 'react-toastify'
import Loader from '../../utilities/Loader/Loader'

const TreatedApplications = ({name}) => {
    const [loading, setLoading] = useState(false)
    const [applications, setApplications] = useState([])
    const [currentApplication, setCurrentApplication] = useState(null)
    const [treatOpen, setTreatOpen] = useState(false)
    const [isTreatLoading, setIsTreatLoading] = useState(false)
    const [filter, setFilter] = useState({
        search: '', 
        status: '',
        from: '',
        to: ''
    })

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const handleStatusOpen = async(application, status) => {
        await setCurrentApplication({...application, treatStatus: status})
        await setTreatOpen(true)
    }
    
    const fetchPendingApplications = () => {
        setLoading(true)
        axiosInstance.post(`/association/associations/applications/all?page=${page}`, filter)
              .then(response => {
                setApplications(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    const treatApplication = () => {
        setTreatOpen(false)
        setIsTreatLoading(true)
        axiosInstance.post(`/association/associations/applications/treat/${currentApplication.id}`, currentApplication)
              .then(res => {
                toast.success(res.data.message)
                fetchPendingApplications()
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setIsTreatLoading(false))
    }

    useEffect(() => {
        setFilter(prevFilter => {
            return {...prevFilter, mode: 'closed'}
        })
        fetchPendingApplications()
    }, [page, name])

  return (
    <>
        <div className="border mb-4 border-dashed pb-3 border-end-0 border-start-0">
            <div className="row g-2">
                <div className="col-xl-3 col-md-6">
                    <div className="search-box">
                        <input 
                            type="text" 
                            className="form-control search" 
                            placeholder="Search applicants..."
                            name="search"
                            value={filter.search}
                            onChange={handleFilterChange} 
                            />
                        <i className="ri-search-line search-icon"></i>
                    </div>
                </div>
                <div className="col-xl-2 col-md-4">
                    <div className="input-group">
                        <span className="input-group-text" id="basic-addon2">From</span>
                        <input 
                            type="date" 
                            className="form-control" 
                            placeholder="Start Date"
                            name='from'
                            value={filter.from}
                            onChange={handleFilterChange} 
                            />
                    </div>
                </div>
                {/* <!--end col--> */}
                <div className="col-xl-2 col-md-4">
                    <div className="input-group">
                        <span className="input-group-text" id="basic-addon2">To</span>
                        <input 
                            type="date" 
                            className="form-control" 
                            placeholder="Start Date" 
                            name='to'
                            value={filter.to}
                            onChange={handleFilterChange}
                            />
                    </div>
                </div>
                {/* <!--end col--> */}
                <div className="col-xl-2 col-md-4">
                    <select 
                        className="form-control" 
                        name='status'
                        value={filter.status}
                        onChange={handleFilterChange}
                        >
                        <option value="">Select Status</option>
                        <option value="approved">Approved</option>
                        <option value="declined">Rejected</option>
                        {/* <option value="Pending">Pending</option> */}
                    </select>
                </div>
                {/* <!--end col--> */}
                <div className="col-xl-1 col-md-4">
                    <button className="btn btn-success w-100" onClick={fetchPendingApplications}>Filter</button>
                </div>
            </div>
            {/* <!--end row--> */}
        </div>
        <div className="table-responsive table-card">
            {applications.length > 0 && (
                <>
                    <table
                        className="table table-borderless table-centered align-middle table-nowrap mb-0">
                        <thead className="text-muted table-light">
                            <tr>
                                <th scope="col">S/N</th>
                                <th scope="col">Applicant Info</th>
                                <th scope="col">Date</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {applications.map(application => (
                                <tr key={application.id}>
                                    <td>
                                        <a href="apps-ecommerce-order-details.html"
                                            className="fw-medium link-primary">1</a>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 me-2">
                                                <img src="/assets/images/users/avatar-1.jpg"
                                                    alt=""
                                                    className="avatar-xs rounded-circle" />
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className='m-0'>{application.user?.last_name} {application.user?.first_name} {application.user?.middle_name}</p>
                                                <p className='m-0 text-muted'>{application.user?.email}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{application.created_at}</td>
                                    <td>
                                        <span
                                            className={`badge ${application.status == 'approved' ? 'bg-success-subtle text-success' :
                                                application.status == 'pending' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'
                                            } text-uppercase`}>{application.status}</span>
                                    </td>
                                    <td>
                                        <div className="dropdown">
                                            <button className="btn btn-light btn-icon btn-sm fs-16 dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="ri-equalizer-fill"></i>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li><a className="dropdown-item"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</a></li>
                                                {application.status == 'declined' && (
                                                    <li onClick={() => handleStatusOpen(application, 'approved')}>
                                                        <a className="dropdown-item cursor-pointer">
                                                            <i className="ri-star-fill text-muted me-2 align-bottom"></i>Approve
                                                        </a>
                                                    </li>
                                                )}
                                                {application.status == 'approved' && (
                                                    <li onClick={() => handleStatusOpen(application, 'declined')}>
                                                        <a className="dropdown-item cursor-pointer">
                                                            <i className="ri-star-fill text-muted me-2 align-bottom"></i>Decline
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {/* <!-- end tr --> */}
                        </tbody>
                    </table>
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                        {/* <div className="col-sm-6">
                            <div>
                                <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                            </div>
                        </div> */}
                        {/* <!-- end col --> */}
                        <div className="col-sm-12 d-flex justify-content-end mt-4">
                            <Pagination 
                                onChange={handlePageChange}  
                                count={pageCount} 
                                color="primary" 
                                shape="rounded"
                                size="small"
                                page={page}
                            />
                        </div>
                        {/* <!-- end col --> */}
                    </div>
                </>
            )}
            {applications.length == 0 && (
                <div className="noresult">
                    <div className="text-center">
                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                    </div>
                </div>
            )}
        </div>

        {/* Treat Application Dialog */}
        {currentApplication && (
          <>
            <Dialog
              open={treatOpen}
              onClose={() => setTreatOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {currentApplication.treatStatus == 'approved' ? 'Approve' : 'Decline'} <b className="text-primary">
                    {currentApplication.user?.last_name} {currentApplication.user?.first_name} 
                </b>'s {" "} application
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={() => setTreatOpen(false)}>
                  Cancel
                </Button>
                <Button onClick={treatApplication} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {isTreatLoading && <Loader />}
            </Dialog>

            {loading && <Loader />}
          </>
        )}
    </>
  )
}

export default TreatedApplications
